import {
    VIDFLEET_DMS_STATUS_REQUEST,
    VIDFLEET_DMS_STATUS_RESULT,
} from 'Redux/actionTypes';

export const dmsStatusRequest = (filters) => ({
    type: VIDFLEET_DMS_STATUS_REQUEST,
    payload: { filters }
});

export const dmsStatusResult = (data) => ({
    type: VIDFLEET_DMS_STATUS_RESULT,
    payload: data
});